import { Theme } from '@material-ui/core/styles';
import { SwitchClassKey } from '@material-ui/core/Switch';

const MuiSwitch = (theme: Theme): Partial<Record<SwitchClassKey, unknown>> => {
    const backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700];

    return {
        /* Styles applied to the root element. */
        root: {
            width: 48,
            height: 42,
            padding: 0,
            alignItems: 'center',
        },

        /* Styles applied to the internal SwitchBase component's root element if `color="primary"`. */
        colorPrimary: {
            '&$checked': {
                color: theme.palette.primary.main,
            },
            '&$disabled': {
                color: theme.palette.grey[400],
            },
            '&$checked + $track': {
                backgroundColor,
                opacity: 1,
            },
            '&$disabled + $track': {
                backgroundColor: theme.palette.action.disabledBackground,
                borderColor: 'transparent',
            },
        },
        /* Styles applied to the internal SwitchBase component's root element if `color="secondary"`. */
        colorSecondary: {
            '&$checked': {
                color: theme.palette.secondary.main,
            },
            '&$disabled': {
                color: theme.palette.grey[400],
            },
            '&$checked + $track': {
                backgroundColor,
                opacity: 1,
            },
            '&$disabled + $track': {
                backgroundColor: theme.palette.action.disabledBackground,
                borderColor: 'transparent',
            },
        },
        /* Styles applied to the internal `SwitchBase` component's `root` class. */
        switchBase: {
            top: 'inherit',
            width: 24,
            height: 24,
            padding: 0,
            color: theme.palette.grey[400],
            '&$checked': {
                transform: 'translateX(24px)',
            },
            '&$checked + $track': {
                opacity: 1,
            },
            '&$disabled + $track': {
                opacity: 1,
            },
        },
        /* Styles used to create the thumb passed to the internal `SwitchBase` component `icon` prop. */
        thumb: {
            boxShadow: 'none',
            width: 14,
            height: 14,
        },
        /* Styles applied to the track element. */
        track: {
            width: 48,
            height: 24,
            boxSizing: 'border-box',
            borderRadius: 48 / 2,
            border: `2px solid ${theme.palette.grey[400]}`,
            backgroundColor,
            opacity: 1,
        },
    };
};

export default MuiSwitch;
